import React from 'react';


class Footer extends React.Component {

    render() {

        return (

            <p></p>

        )

    }
}


export default Footer;
